import { c as _c } from "react/compiler-runtime";
import * as React from 'react';
import { SearchFiltersContextValue, useSearchFilters } from './search-filters-context';
import { SearchMapContextValue, useSearchMap } from './search-map-context';
import { SearchResultsContextValue, useSearchResults } from './search-results-context';
import { SearchUIContextValue, useSearchUI } from './search-ui-context';
export type SearchContextCombined = SearchFiltersContextValue & SearchMapContextValue & SearchResultsContextValue & SearchUIContextValue;
export const useSearch = () => {
  const $ = _c(5);
  const filters = useSearchFilters();
  const map = useSearchMap();
  const results = useSearchResults();
  const ui = useSearchUI();
  let t0;
  if ($[0] !== filters || $[1] !== map || $[2] !== results || $[3] !== ui) {
    t0 = {
      ...filters,
      ...map,
      ...results,
      ...ui
    };
    $[0] = filters;
    $[1] = map;
    $[2] = results;
    $[3] = ui;
    $[4] = t0;
  } else {
    t0 = $[4];
  }
  return t0;
};